<template>
  <!--
      作者：kmdshop
      描述：邀请活动管理
  -->
  <div class="invitation">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input size="small" v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="活动状态">
          <el-select size="small" v-model="searchForm.status" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="未完成" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!--内容-->
    <div class="invitation-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部活动" name="all"></el-tab-pane>
          <el-tab-pane :label="'未完成(' + event_count.unfinished + ')'" name="unfinished"></el-tab-pane>
          <el-tab-pane :label="'进行中(' + event_count.processing + ')'" name="processing"></el-tab-pane>
          <el-tab-pane :label="'已完成(' + event_count.finished + ')'" name="finished"></el-tab-pane>
        </el-tabs>
        
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="invitationevent_id" label="活动ID" width="80"></el-table-column>
          <el-table-column prop="user_nickname" label="用户名" width="100"></el-table-column>
           <el-table-column prop="user_mobile" label="用户手机号" width="100"></el-table-column>
          <el-table-column prop="current_amount" label="已获得金额" width="120">
            <template slot-scope="scope">
              <div class="orange">￥{{ scope.row.current_amount }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="target_amount" label="目标金额" width="120">
            <template slot-scope="scope">
              <div>￥{{ scope.row.target_amount }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="已助力人数" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.num }}/{{ scope.row.required_invites }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="friend_count" label="好友数" width="100"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 0 ? 'info' : scope.row.status === 1 ? 'warning' : 'success'"
                size="small"
              >
                {{ scope.row.status === 0 ? '未完成' : scope.row.status === 1 ? '进行中' : '已完成' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="complete_time" label="完成时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.complete_time || '-' }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="viewDetail(scope.row)" type="text" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增/编辑活动弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="用户ID" prop="user_id">
          <el-input v-model="form.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="目标金额" prop="target_amount">
          <el-input v-model="form.target_amount" placeholder="请输入目标金额">
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="需邀请人数" prop="required_invites">
          <el-input-number v-model="form.required_invites" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">未完成</el-radio>
            <el-radio :label="1">进行中</el-radio>
            <el-radio :label="2">已完成</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 活动详情弹窗 -->
    <el-dialog title="活动详情" :visible.sync="detailDialogVisible" width="80%">
      <div v-if="currentEvent">
        <el-descriptions title="活动信息" :column="2" border>
          <el-descriptions-item label="活动ID">{{ currentEvent.invitationevent_id }}</el-descriptions-item>
          <el-descriptions-item label="用户ID">{{ currentEvent.user_id }}</el-descriptions-item>
          <el-descriptions-item label="已获得金额">￥{{ currentEvent.current_amount }}</el-descriptions-item>
          <el-descriptions-item label="目标金额">￥{{ currentEvent.target_amount }}</el-descriptions-item>
          <el-descriptions-item label="已助力人数">{{ currentEvent.num }}/{{ currentEvent.required_invites }}</el-descriptions-item>
          <el-descriptions-item label="好友数">{{ currentEvent.friend_count }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="currentEvent.status === 0 ? 'info' : currentEvent.status === 1 ? 'warning' : 'success'">
              {{ currentEvent.status === 0 ? '未完成' : currentEvent.status === 1 ? '进行中' : '已完成' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentEvent.create_time }}</el-descriptions-item>
          <el-descriptions-item label="完成时间">{{ currentEvent.complete_time || '-' }}</el-descriptions-item>
        </el-descriptions>
        
        <div style="margin-top: 20px;">
          <h3>助力记录</h3>
          <el-table :data="helperList" border style="width: 100%">
            <el-table-column prop="helper_id" label="助力者ID" width="100"></el-table-column>
            <el-table-column prop="helper_nickname" label="助力者昵称" width="150"></el-table-column>
            <el-table-column prop="amount" label="助力金额" width="120">
              <template slot-scope="scope">
                <div class="orange">￥{{ scope.row.amount }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="is_new_user" label="是否新用户" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.is_new_user ? 'success' : 'info'" size="small">
                  {{ scope.row.is_new_user ? '新用户' : '老用户' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="助力时间" width="180"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
//import InvitationApi from '@/api/invitation.js'

export default {
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单*/
      searchForm: {
        user_id: '',
        status: '',
        create_time: ''
      },
      /*统计*/
      event_count: {
        unfinished: 0,
        processing: 0,
        finished: 0
      },
      /*弹窗相关*/
      dialogFormVisible: false,
      detailDialogVisible: false,
      dialogTitle: '新增活动',
      /*表单数据*/
      form: {
        invitationevent_id: '',
        user_id: '',
        target_amount: '',
        required_invites: 1,
        status: 1
      },
      /*表单验证规则*/
      rules: {
        user_id: [
          { required: true, message: '请输入用户ID', trigger: 'blur' }
        ],
        target_amount: [
          { required: true, message: '请输入目标金额', trigger: 'blur' }
        ],
        required_invites: [
          { required: true, message: '请输入需邀请人数', trigger: 'blur' }
        ]
      },
      /*当前活动详情*/
      currentEvent: null,
      /*助力记录列表*/
      helperList: []
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab) {
      this.curPage = 1;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = {...this.searchForm};
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      
      OrderApi.eventlist(Params, true)
        .then(res => {
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.event_count = res.data.event_count;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*显示新增弹窗*/
    showAddDialog() {
      this.dialogTitle = '新增活动';
      this.form = {
        invitationevent_id: '',
        user_id: '',
        target_amount: '',
        required_invites: 1,
        status: 1
      };
      this.dialogFormVisible = true;
    },

    /*编辑活动*/
    editEvent(row) {
      this.dialogTitle = '编辑活动';
      this.form = {...row};
      this.dialogFormVisible = true;
    },

    /*删除活动*/
   

    /*查看详情*/
    viewDetail(row) {
      this.currentEvent = row;
      // 获取助力记录
      OrderApi.getHelperList({ invitationevent_id: row.invitationevent_id })
        .then(res => {
          this.helperList = res.data.list;
          this.detailDialogVisible = true;
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: '获取助力记录失败!'
          });
        });
    },

  }
};
</script>

<style lang="scss" scoped>
.invitation {
  .orange {
    color: #ff6700;
  }
  
  .table-wrap {
    margin-top: 20px;
  }
  
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/order/invitation.vue